import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    save: { data: {} },
    table: createTableState(),
    filterData: undefined,
    stockId: null,
})

const getters = {}

const actions = {
    async get({state, commit}, {stockId, filterData} = {}) {
        commit('setLoading', true)
        commit('updateTableData', [])

        if (stockId) state.stockId = stockId
        state.filterData = filterData

        try {
            const res = await this._vm.axios.get(this._vm.endpoints['company_stock_location'], {
                urlVars: { stockId: state.stockId },
                params: filterData || {},
            })
            const { data, meta } = res.data
            commit('updateTableData', data || [])
            if (meta) {
                commit('updatePagination', normalizePagination(meta))
            } else {
                const total = (data || []).length
                commit('updatePagination', { current: 1, pageSize: total || 1, total, sort: [] })
            }
        } finally {
            setTimeout(() => commit('setLoading', false), 250)
        }
    },

    async add({commit, dispatch}, {stockId, formData}) {
        try {
            const res = await this._vm.axios.post(
                this._vm.endpoints['company_stock_location'],
                formData,
                { urlVars: { stockId } },
            )
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        }
    },

    async delete({commit, dispatch, state}, {stockId, locationId}) {
        try {
            const res = await this._vm.axios.delete(
                this._vm.endpoints['company_stock_location'] + '/' + locationId,
                { urlVars: { stockId } },
            )
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        }
    },

    refresh({dispatch, state}) {
        dispatch('get', { stockId: state.stockId, filterData: state.filterData })
    },
}

const mutations = {
    setLoading(state, val) { state.table.loading = val },
    updateTableData(state, data) { state.table.data = data },
    updatePagination(state, pagination) { state.table.pagination = pagination },
    updateSaveData(state, data) { state.save.data = data },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
